import { googleOneTap } from "vue3-google-login";

export default defineNuxtRouteMiddleware(async (to, from) => {
  const user = useUserStore();
  const equipment = useEquipmentStore();

  console.log("from.path", from.path);

  //因为需要通过/s/[:id]的动态id请求接口，所以写在路由中间件处理
  //facebook授权回调不执行
  if (from.path !== "/callback/facebook") {
    let id = from.params.id as string;

    if (from.path === "/autologin") {
      //telegram miniapp
      const parsedUrl = new URL(
        window.location.origin + from.fullPath.split("#")[0]
      );

      const tgWebAppStartParam =
        parsedUrl.searchParams.get("tgWebAppStartParam");

      if (tgWebAppStartParam?.startsWith("sm-")) {
        id = tgWebAppStartParam.replace("sm-", "");
      }
    }

    if (id) {
      const { data, error } = await useAsyncData(
        `metaData${new Date()}`,
        async () => {
          const res = await api_innerShareOpenUrl(id);
          const json = await res.json(); // 这里解析响应体
          return json;
        }
      );

      console.log("api_innerShareOpenUrl", data);

      if (data.value?.data?.detail) {
        const oginfo = computed(() => data.value?.data?.detail);

        user.setShareOpenConfig(oginfo.value);
        user.setinviterCodeFn(oginfo.value?.inviterCode);

        if (import.meta.server && oginfo) {
          let meta = [
            {
              property: "og:title",
              content: oginfo.value?.shareMessage.shareTitle,
            },
            {
              property: "og:url",
              content: oginfo.value?.redirectUrl,
            },
            {
              property: "og:description",
              content: oginfo.value?.shareMessage.shareDesc,
            },
            {
              property: "og:image:height",
              content: "1920",
            },
            {
              property: "og:image:width",
              content: "1080",
            },
            {
              property: "twitter:card",
              content: "summary_large_image",
            },
            {
              property: "twitter:title",
              content: oginfo.value?.shareMessage.shareTitle,
            },
            {
              property: "twitter:description",
              content: oginfo.value?.shareMessage.shareDesc,
            },
          ];
          if (oginfo.value?.shareMessage.shareImages) {
            meta.push({
              property: "twitter:image",
              content: oginfo.value?.shareMessage.shareImages[0],
            });
            meta.push({
              property: "og:image",
              content: oginfo.value?.shareMessage.shareImages[0],
            });
          }
          useHead({
            meta,
          });
        }

        const token = useCookie("sv-token", {
          httpOnly: false,
          maxAge: 15 * 60, // 15分钟
        });

        console.log("token", token.value);

        if (token.value) {
          user.isLogin = true;
          user.token = token.value;

          handlerNextStepFn();
        } else {
          user.isLogin = false;
          user.token = "";
        }

        if (import.meta.client) {
          const isSupportGoogle = Boolean(await checkGoogleAccess());
          console.log("isSupportGoogle", isSupportGoogle);

          if (oginfo.value?.mustLogin && isSupportGoogle) {
            try {
              console.log("telegram login.global.ts");

              console.log("telegram user.isLogin", user.isLogin);
              console.log("telegram to.path", to.path);
              console.log(
                "equipment.browserPlatform",
                equipment.browserPlatform
              );
              console.log(
                "equipment.facebook_app_id",
                equipment.facebook_app_id
              );
              console.log("user.faceBookIsLoadLogin", user.faceBookIsLoadLogin);

              const tg: any = window?.Telegram?.WebApp;

              if (!user.isLogin) {
                if (
                  equipment.facebook_app_id &&
                  equipment.browserPlatform === BROWSER_PLATFORM.FACEBOOK &&
                  !user.faceBookIsLoadLogin
                ) {
                  //facebook 自动登录
                  if (user.shareOpenConfig?.facebookLoginMode === "auth2") {
                    oauthFacebookLogin(btoa(to.fullPath));
                    user.loginMethod = "auth-facebook";
                  } else {
                    user.faceBookIsLoadLogin = true;
                    facebookCheckLogin();
                    user.loginMethod = "facebook";
                  }
                } else if (
                  equipment.browserPlatform === BROWSER_PLATFORM.SAFARI
                ) {
                  //Apple登录  无感登录会有限制，需要用户手动触发
                  user.loginMethod = "apple";
                  showLConfirmLoginDialog();
                } else if (
                  equipment.browserPlatform === BROWSER_PLATFORM.DEFAULT &&
                  !user.telegramIsLoadLogin &&
                  !(!tg.platform || tg.platform === "unknown")
                ) {
                  //telegram小程序自动登录
                  console.log("telegram initData");
                  user.loginMethod = "telegram";

                  await autoLoginTelegramInit().catch(() => {
                    handlerNextStepFn();
                  });
                  user.telegramIsLoadLogin = true;
                } else if (
                  equipment.browserPlatform === BROWSER_PLATFORM.DEFAULT
                ) {
                  //Google登录
                  /**移除谷歌cookkie标识，确保每次都能被拉起 */
                  user.loginMethod = "google";

                  removeToken("g_state");

                  googleOneTap({ autoLogin: true })
                    .then((response) => {
                      console.log("googleOneTap", response);
                      api_loginWithGoogle(response.credential)
                        .then(async ({ res }) => {
                          await user.handLoginResponse({
                            ...res.data,
                            method: "google",
                          });
                        })
                        .catch(() => {
                          handlerNextStepFn();
                        });
                    })
                    .catch((err) => {
                      console.error("Google One Tap failed:", err); // 打印详细错误信息
                      handlerNextStepFn();
                    });
                }
              } else {
                user.faceBookIsLoadLogin = false;
                user.telegramIsLoadLogin = false;
                handlerNextStepFn();
              }
            } catch (error) {
              console.log("@@@catch auto login error", error);
              handlerNextStepFn();
            }
          } else {
            handlerNextStepFn();
          }
        }
      }
    }
  }
});
